import React from 'react';

import { IDropdown } from './Spinner';
import { SpinnerUI } from './SpinnerElements';

const Spinner: React.FC<IDropdown.IProps> = (props) => {
  const { isLoading, className } = props;
  if (!isLoading) return null;
  return <SpinnerUI className={className} />;
};

export { Spinner };
